import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagUs = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 16",
	width: 24,
	height: 16,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 16,
			fill: "#B22234"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 1.231,
			width: 24,
			height: 1.231,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 3.692,
			width: 24,
			height: 1.231,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6.154,
			width: 24,
			height: 1.231,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 8.615,
			width: 24,
			height: 1.231,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 11.077,
			width: 24,
			height: 1.231,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 13.538,
			width: 24,
			height: 1.231,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 9.6,
			height: 8.615,
			fill: "#3C3B6E"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .8,
			cy: .479,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.4,
			cy: .479,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: .479,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.6,
			cy: .479,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.2,
			cy: .479,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.8,
			cy: .479,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.6,
			cy: 1.436,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.2,
			cy: 1.436,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.8,
			cy: 1.436,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.4,
			cy: 1.436,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 1.436,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .8,
			cy: 2.392,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.4,
			cy: 2.392,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: 2.392,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.6,
			cy: 2.392,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.2,
			cy: 2.392,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.8,
			cy: 2.392,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.6,
			cy: 3.349,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.2,
			cy: 3.349,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.8,
			cy: 3.349,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.4,
			cy: 3.349,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 3.349,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .8,
			cy: 4.305,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.4,
			cy: 4.305,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: 4.305,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.6,
			cy: 4.305,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.2,
			cy: 4.305,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.8,
			cy: 4.305,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.6,
			cy: 5.262,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.2,
			cy: 5.262,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.8,
			cy: 5.262,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.4,
			cy: 5.262,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 5.262,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .8,
			cy: 6.218,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.4,
			cy: 6.218,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: 6.218,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.6,
			cy: 6.218,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.2,
			cy: 6.218,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.8,
			cy: 6.218,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.6,
			cy: 7.174,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.2,
			cy: 7.174,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.8,
			cy: 7.174,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.4,
			cy: 7.174,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 7.174,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .8,
			cy: 8.131,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.4,
			cy: 8.131,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: 8.131,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.6,
			cy: 8.131,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.2,
			cy: 8.131,
			r: .38,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.8,
			cy: 8.131,
			r: .38,
			fill: "#fff"
		})
	]
});
export default SvgFlagUs;
